export default "__VITE_ASSET__qGHs4qCT__"